import { useConfig } from 'Components/ConfigProvider';
import themes from 'themes';

/**
 * getTheme DEPRECATED, use configProvider and themeProvider instead
 */
export const getTheme = () => {
  const config = useConfig();
  return themes[config.PACKAGE_SUFFIX];
};

export default getTheme;
